import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { EChartsOption } from 'echarts';
import { IPotentialSavingsSteadyStateDTO } from '../dto/i-potential-savings-steady-state.dto';
import { LinuxUncoveredConfig } from './linux-uncovered.config';

@Component({
	selector: 'app-linux-uncovered',
	templateUrl: './linux-uncovered.component.html',
	styleUrls: ['./linux-uncovered.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinuxUncoveredComponent implements OnChanges {
	@Input() public data: IPotentialSavingsSteadyStateDTO;

	@Output() public openTotalSavingPanel: EventEmitter<void> = new EventEmitter<void>();

	public chartUpdatedOption: EChartsOption = LinuxUncoveredConfig;

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.data?.currentValue) {
			this.handleDataUpdate(changes.data.currentValue);
		}
	}

	private handleDataUpdate(data: IPotentialSavingsSteadyStateDTO): void {
		if (!data || !data.ondemandPerDay || !Object.keys(data.ondemandPerDay).length) {
			this.chartUpdatedOption = LinuxUncoveredConfig;
			return;
		}
		const xAxisData = Object.keys(data.ondemandPerDay).sort();
		const steadyStateSeries = xAxisData.map(() => data.steadyState);
		const onDemandPerDaySeries = xAxisData.map((date: string) => data.ondemandPerDay[date]);
		const series = [onDemandPerDaySeries, steadyStateSeries];
		this.chartUpdatedOption = {
			...this.chartUpdatedOption,
			xAxis: [
				{
					...this.chartUpdatedOption.xAxis,
					...{ data: xAxisData },
				},
			],
			series: (this.chartUpdatedOption.series as any).map((item, idx) => ({
				...item,
				...{ data: series[idx].map((item) => item.toFixed(2)) },
			})),
		};
	}
}
